import {PlayerBase} from "../../player/player.base";
import {Component, Injector, Pipe, PipeTransform, ViewChild} from '@angular/core';
import {Observable, of, switchMap, takeUntil, timer} from "rxjs";
import {catchError, delay, tap} from "rxjs/operators";
import {lastMap} from "../../rxjs/lastMap";
import {ChromeExtension} from "../../services/Watchdog/ChromeExtension";
import {Log, LogTag} from "../../services/Log";

@Component({
  selector: 'app-html',
  template: '<div #component><iframe #myFrame  loading="lazy" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; border: none; padding: 0;margin: 0; pointer-events: none"></iframe></div>',
  styleUrls: []
})
export class CanvaComponent extends PlayerBase {
  requiredCheck = false;

  @ViewChild('myFrame', {static: true} ) myFrame;

  constructor(protected  injector: Injector) {
    super(injector);
  }

  load(playerObject: any): Observable<any> {
    let self;
    return super.load(playerObject).pipe(
      switchMap( playerBase => {
        self = playerBase;

        let url = this.data.Canva[0].$.embeddedLink;
        if (url==null || url=="") {
          this.showMsg(this.playerObject.$.label, 'Please set the Canva URL to embed your content');
        } else {
          this.showMsg(null, null);
          url += "?embed";
          this.myFrame.nativeElement.src = url;
        }
        return of('a');
      }),
      catchError(err => this.logError(err) ),
      switchMap(a => of(self)),
      takeUntil(this.finish$)
    )
  }

  play(): Observable<any> {
    if (this.editMode) {
      return of(null);
    }

    const play$ = super.play();
    return play$.pipe(
      switchMap( a=> {
        return of('play')
      }),
    )
  }

  destroy(): void {
    if (this.myFrame?.nativeElement?.onload!=null) {
      this.myFrame.nativeElement.onload = null;
    }
    super.destroy();
  }
}
